/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#displayAdditionalSearchResult__anchor
 */
export default result => {
  window.documentViewer.displayAdditionalSearchResult(result);
};
